module.exports = __webpack_public_path__ + "img/Misi1-3-4Piramida.28d6be12.png";